enum TrialType {
  TRABALHISTA = 'Trabalhista',
  FEDERAL = 'Federal',
  CIVEL = 'Cível',
  STF = 'STF',
  CNJ = 'CNJ',
  STJ = 'STJ',
  ELEITORAL = 'Eleitoral',
  MILITAR_F = 'Militar F',
  MILITAR_E = 'Militar E',
}

export default TrialType;
